import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Container from '../../components/container';

import { ReactComponent as BackButton } from './img/back-button.svg';
import { ReactComponent as EditButton } from './img/edit-button.svg';

import './company.scss';

import CompanyInfoPopUp from '../../popups/company.info';
import useGlobal from '../../../store';
import useReloadDummy from '../../../scripts/hooks/use.reload.dummy';
import MenuMobile from '../../components/menu-mobile';
import { format } from 'date-fns';


const Company = () => {

  const { id } = useParams();
  const navigate = useNavigate();
  const [ globalState, globalActions ] = useGlobal();

  const { user, subscribe } = globalState;

  const { users, changeStates } = globalActions;

  const [ CompanyPopup, showCompanyPopup ] = CompanyInfoPopUp();

  const [ Dummy, reloadDummy ] = useReloadDummy();

  useEffect(() => {

    if ( !id || id === "" ) { window.location = "/companies"; }
    else { users.get( id, reloadDummy ); console.log(`uEF companies.get id="${ id }"`); }    

  }, [ id ]);

  const [ mobilePage, setMobilePage ] = useState(11);
  
  return (

    <Container className = "container__company relative">

      <MenuMobile main = { false } section = { mobilePage } action = { setMobilePage }/>

      <Dummy />

      { CompanyPopup }

      <div className={`flex row company-header company-header-${ mobilePage }`} draggable="false">

        <BackButton 
        
          title = "Назад к таблице франшиз"
          className = "company-header__button desktop-flex"
          onClick = {() => {
            
            users.clearCompanyStates();
            navigate('/companies') 
          
          }} 
          
        />

        <p className="montserrat font-semibold company__pagename">Компания { user.company_name }</p>
        
        {/* <ToggleChecker
        
          value = { company.active }
          text = { company.active ? "Доступ активирован" : "Доступ закрыт" }
          set = { ( bool ) => { users.changeInfo( company.id, { active: bool } ) }}
        
        /> */}

        {/* { !company.active &&
        
          <p 
          
            title = "Безвозвратно удалить франшизу и всё что с ней связано"
            className = "rmv_company_btn"
            onClick = { () => users.remove( id ) }
            
          >удалить франшизу</p> 
          
        } */}

      </div>

      <div className={`company-columns company-columns--mobile-page-${ mobilePage }`} draggable="false">

        <div className="company-columns__info flex col" draggable="false">

          <div className="company-columns__common company-columns__information">

            <div className="company-columns__common__header flex row">

              <p className="montserrat semibold company-head company-head company-head-info">Информация</p>

              <EditButton 
              
                className="company__info__edit-button"
                onClick={ showCompanyPopup }
                
              />

            </div>

            <div className="company-columns__common__body flex">

              <div className="flex anal">
                <p className="montserrat semibold company-head graytext">Добавлена:</p>
                <p className="montserrat semibold company-head">{ user?.created_at ? format( user.created_at, 'dd.MM.yyyy hh:mm') : "-" }</p>
              </div>

              <div className="flex anal">
                <p className="montserrat semibold company-head graytext">Доступ активен до:</p>
                <p className="montserrat semibold company-head">{ subscribe?.dateEnd ? format( subscribe.dateEnd, 'dd.MM.yyyy hh:mm') : "-" } (осталось { subscribe?.remainingDays > 0 ? subscribe.remainingDays : '0' } дней)</p>
              </div>

              <div className="flex anal">
                <p className="montserrat semibold company-head graytext">Владелец:</p>
                <p className="montserrat semibold company-head">{ user.fio }</p>
              </div>


              <div className="flex anal">
                <p className="montserrat semibold company-head graytext">Телефон:</p>
                <a href={`tel:${ user.phone }`} className="montserrat semibold company-head">{ user.phone }</a>
              </div>


              <div className="flex anal">
                <p className="montserrat semibold company-head graytext">Комментарий</p>
                <p className="montserrat semibold company-head">{ user?.comment || "" }</p>
              </div>

            </div>

          </div>
        
        </div>

      </div>

    </Container>

  );

}

export default Company;